import { graphql } from '../gql'

/**
 * GraphQL operations for the current user (me).
 */

/** Query: Get the current logged-in operator. */
export const CurrentUserQuery = graphql(`
	query CurrentUserQuery {
		me {
			id
			firstName
			lastName
			flags

			organization {
				id
				name
				logo
				primaryColor
				billingProfile {
					currency
					locale
				}
				config {
					customerApp {
						requestPreWorkAuthorization
					}
					crew {
						assignmentHideDetailsTillAck
						assignmentReportAtDuration
						orderAllowOperatorToCancel
						workTicketRequireSignature
					}
					modules {
						timeclocks
					}
					localization {
						useCubicMeters
					}
				}
			}
		}
	}
`)
